import React, { useContext } from "react";
import { TranslatorContext } from "../../context/Translator";
import { Col } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

function TotalGroupsRecord({ data }) {
  const { t } = useContext(TranslatorContext);
  const navigate = useNavigate();

  const handleCardClick = (key) => {
    navigate(`/act-group-details/${key}`);
  };

  const cards = [
    // ===== BASIC INFO =====
    // {
    //   key: "last_updated",
    //   title: "Last Updated",
    //   icon: "update",
    //   trend: "event",
    //   number: data?.last_updated_date,
    // },

    // ===== GROUP COUNTS =====
    { key: "total_groups", title: "Total Groups", icon: "groups", number: data?.total_groups },
    { key: "male_groups", title: "Total Male Groups", icon: "male", number: data?.total_male_groups },
    { key: "female_groups", title: "Total Female Groups", icon: "female", number: data?.total_female_groups },

    // ===== MEMBER COUNTS =====
    { key: "male_members", title: "Total Male Members", icon: "man", number: data?.total_male_members },
    { key: "female_members", title: "Total Female Members", icon: "woman", number: data?.total_female_members },
    { key: "total_members", title: "Total Members", icon: "group", number: data?.total_members },

    {
      key: "avg_members",
      title: "Avg Members / Group",
      icon: "functions",
      number:
        data?.total_groups > 0
          ? (data.total_members / data.total_groups).toFixed(2)
          : 0,
    },

    // ===== GROUP STATUS =====
    { key: "groups_25", title: "Groups with 25 Members", icon: "verified", number: data?.groups_25 },

    {
      key: "groups_25_percent",
      title: "% Groups Reached Max",
      icon: "percent",
      number:
        data?.total_groups > 0
          ? ((data.groups_25 / data.total_groups) * 100).toFixed(2) + "%"
          : "0%",
    },

    // ===== FAMILY COUNTS =====
    {
      key: "rescued",
      title: "Total Rescued Families",
      icon: "check_circle",
      number: `${data?.rescued_count} (${data?.rescued_percent}%)`,
    },
    {
      key: "to_be_rescued",
      title: "To Be Rescued Families",
      icon: "pending",
      number: `${data?.to_be_rescued_count} (${data?.to_be_rescued_percent}%)`,
    },
    {
      key: "community",
      title: "Community Families",
      icon: "diversity_3",
      number: `${data?.community_count} (${data?.community_percent}%)`,
    },

    // ===== SAVINGS =====
    { key: "total_savings", title: "Total Savings", icon: "savings", number: data?.total_savings },
    { key: "avg_saving", title: "Average Saving Amount", icon: "account_balance", number: data?.avg_saving },

    {
      key: "avg_saving_group",
      title: "Avg Saving / Group",
      icon: "calculate",
      number:
        data?.total_groups > 0
          ? (data.total_savings / data.total_groups).toFixed(2)
          : 0,
    },
    {
      key: "avg_saving_member",
      title: "Avg Saving / Member",
      icon: "calculate",
      number:
        data?.total_members > 0
          ? (data.total_savings / data.total_members).toFixed(2)
          : 0,
    },

    // ===== MEETINGS =====
    {
      key: "avg_meetings",
      title: "Avg Meetings / Group",
      icon: "event_repeat",
      number: data?.avg_meetings,
    },

    // ===== MATERIAL DISTRIBUTION =====
    {
      key: "passbook",
      title: "Pass Book Delivered",
      icon: "menu_book",
      number: `${data?.passbook_delivered} (${data?.passbook_percent}%)`,
    },
    {
      key: "saving_box",
      title: "Saving Box Delivered",
      icon: "inventory",
      number: `${data?.saving_box_delivered} (${data?.saving_box_percent}%)`,
    },
    {
      key: "minute_book",
      title: "Minute Book Delivered",
      icon: "description",
      number: `${data?.minute_book_delivered} (${data?.minute_book_percent}%)`,
    },
    {
      key: "loan_ledger",
      title: "Loan Ledger Delivered",
      icon: "receipt_long",
      number: `${data?.loan_ledger_delivered} (${data?.loan_ledger_percent}%)`,
    },
  ];

  return (
    <>
      {cards.map((item) => (
        <Col xl={3} lg={4} md={6} sm={12} key={item.key}>
          <div
            className="mc-ecommerce-card"
            onClick={() => handleCardClick(item.key)}
            style={{
              background: "linear-gradient(to right, rgba(0,0,0,0.85), #077834)",
              cursor: "pointer",
            }}
          >
            <i className="mc-ecommerce-card-trend material-icons text-success">
              {item.trend || "analytics"}
            </i>

            <div className="mc-ecommerce-card-head">
              <h4 className="mc-ecommerce-card-meta">
                <span>{item.title}</span>
                <span>{item.number ?? "-"}</span>
              </h4>

              <i className="mc-ecommerce-card-icon material-icons text-light">
                {item.icon}
              </i>
            </div>
          </div>
        </Col>
      ))}
    </>
  );
}

export default TotalGroupsRecord;
